<template>
  <v-menu>
    <template #activator="{ props }">
      <v-btn
        v-if="auth.isAuthorized()"
        class="ma-2"
        color="info"
        icon="mdi-account"
        size="large"
        v-bind="props"
      />
    </template>
    <v-list>
      <v-list-item
        prepend-icon="mdi-account"
        color="info"
        :subtitle="auth.getUser?.role"
        :title="auth.getUser?.username as string"
      />
      <v-divider />
      <v-list-item prepend-icon="mdi-lock-reset" :to="routes.CHANGE_PASSWORD">
        <v-list-item-title> Change Password </v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item prepend-icon="mdi-logout" :to="routes.LOGOUT">
        <v-list-item-title> Logout </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup lang="ts">
  import useAuth from '@/composables/useAuth/useAuth';
  import Routes from '@/enums/Routes';
  const auth = useAuth();
  const routes = Routes;
</script>
